import React from "react";
import "./nav.css";
import { AiOutlineHome } from "react-icons/ai";
import { AiOutlineUser } from "react-icons/ai";
import { BiBook } from "react-icons/bi";
import { RiServiceLine } from "react-icons/ri";
import { BiMessageSquareDetail } from "react-icons/bi";

const nav = () => {
  return (
    <nav>
      <a href="#header" className="active">
        <AiOutlineHome />
      </a>
      <a href="#about" className="#">
        <AiOutlineUser />
      </a>
      <a href="#experience" className="#">
        <BiBook />
      </a>
      <a href="#service" className="#">
        <RiServiceLine />
      </a>
      <a href="#contact" className="#">
        <BiMessageSquareDetail />
      </a>
    </nav>
  );
};

export default nav;
